module.exports = __webpack_public_path__ + "static/media/instagram-connect.256431dd.png";